export const ProjectProfitTableColumnTypes = {
	BUDGETED: 'budgeted',
	RECOGNIZED_TO_DATE: 'recognized_to_date',
	TO_RECOGNIZE: 'to_recognize',
	INVOICED_TO_DATE: 'invoiced_to_date',
	TO_INVOICE: 'to_invoice',
	FORECASTED: 'forecasted',
} as const;

export const ProjectProfitTableRowTypes = {
	REVENUE: 'revenue',
	COST: 'cost',
	LABOR_COST: 'labor_cost',
	EXTERNAL_COST: 'external_cost',
	TOTAL: 'total',
} as const;
